<template>
  <div v-if="item" class="py-3">
    <div class="d-flex justify-space-between align-center ga-3">
      <div class="text-truncate font-size-14">
        <span>{{ itemTitle }}</span>
        <span v-if="post" class="text-disabled ml-1">({{ post }})</span>
      </div>
      <slot name="actions"></slot>
    </div>
  </div>
  <span v-else>Дані відсутні</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getPersonName } from 'best-modules/utils'

defineOptions({
  name: 'RouteUserItem',
})

const props = defineProps<{
  item: Record<string, any> | null
}>()

const itemTitle = computed(() => {
  return (
    props.item?.entity?.name ||
    getPersonName(props.item?.user) ||
    props.item?.entity?.topic ||
    props.item?.topic ||
    props.item?.subject
  )
})

const post = computed(() => {
  return props.item?.user?.post || props.item?.entity?.description
})
</script>
